
import { hygraphSrcset } from "@/utils/hygraphImage";
import {
  WIDE_SIZES,
  WIDE_WIDTHS,
  READ_SIZES,
  READ_WIDTHS,
} from "@/components/blog/imageSlots";

const RATIOS = {
  RATIO_3_2: "3 / 2",
  RATIO_16_9: "16 / 9",
  RATIO_4_3: "4 / 3",
  RATIO_1_1: "1 / 1",
};

export default {
  name: "ImageBlock",
  props: {
    block: { type: Object, required: true },
  },
  computed: {
    ratio() {
      return RATIOS[this.block.aspectRatio] || "3 / 2";
    },
    // `width` is the editor's layout choice (READING = prose column, anything
    // else = the wider section tier), which decides the display slot.
    isReading() {
      return this.block.width === "READING";
    },
    sizes() {
      return this.isReading ? READ_SIZES : WIDE_SIZES;
    },
    srcset() {
      return hygraphSrcset(
        this.block.image,
        this.isReading ? READ_WIDTHS : WIDE_WIDTHS
      );
    },
  },
};
